import { supabase } from '@/lib/supabase/config';

export async function getAddons(organizationId: number) {
  const { data, error } = await supabase.rpc('get_addon_subscriptions', {
    p_organization_id: organizationId,
  });

  if (error) {
    throw new Error(error.message || 'Failed to get addons');
  }

  return data;
}
